import { ThemeProvider } from "@emotion/react";
import { PureComponent } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import Redirect from "components/Redirect";
import { installAmplitudeNoAuth } from "helpers/analytics";
import { initGoogleFont } from "helpers/app";
import {
  TicketRating,
  TicketRatingAlreadyRated,
  TicketRatingExpired,
  TicketRatingThankYou,
} from "routes/_no-auth/ticket-rating";
import { runNoAuthSagas } from "store/no-auth-sagas";
import { legacyTheme } from "themes/legacyTheme";

import { EmailUnsubscribe } from "./notifications/EmailUnsubscribe";
import { EmailUnsubscribeRequester } from "./notifications/EmailUnsubscribeRequester";

export class Router extends PureComponent<RouteComponentProps> {
  constructor(props: RouteComponentProps) {
    super(props);
    runNoAuthSagas();
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    initGoogleFont();
    installAmplitudeNoAuth();
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return (
      <ThemeProvider theme={legacyTheme}>
        <Switch>
          <Route path="/rate/thank-you" component={TicketRatingThankYou} />
          <Route path="/rate/expired" component={TicketRatingExpired} />
          <Route path="/rate/already-rated" component={TicketRatingAlreadyRated} />
          <Route path="/rate/:rating/:id/:token" component={TicketRating} />
          <Route path="/notifications/:agentID/email/unsubscribe" component={EmailUnsubscribe} />
          <Route path="/requester/email/unsubscribe" component={EmailUnsubscribeRequester} />
          <Redirect to="/" />
        </Switch>
      </ThemeProvider>
    );
  }
}

export default Router;
